import { apiActions } from '../../../_core/api';
import { Middleware } from 'redux';
import { IStore } from '../../../store';
import crbActions, {
    ECRBActions,
    ECRBConstants,
    TCRBActions,
} from '../actions';
import { jobActions } from '../../../_core/job';
import { IAuthActions } from '../../auth/actions';
import { commonUtils } from '../../../_common';
import { TCRBBackendRecord } from '../@types';
import { EMARPOLDocuments, EMARPOLModelName } from 'redux/app/marpol/@types';

const crbHistoryMiddleware: Middleware<{}, IStore> =
    ({ dispatch, getState }) =>
    (next) =>
    (action: TCRBActions | IAuthActions) => {
        switch (action.type) {
            case ECRBActions.HISTORY_LOAD: {
                next(action);
                const job = jobActions(ECRBConstants.FEATURE, action.type);
                const { providedFilters: filters } = action.payload;
                dispatch(crbActions.document.setFilter(filters));

                dispatch(
                    apiActions.apiRequest<{ logs: { docs: TCRBBackendRecord[] } }>({
                        feature: action.type,
                        method: 'GET',
                        url: ECRBConstants.API,
                        queryParams: {
							vesselId: filters.vesselId,
							marpolType: EMARPOLDocuments.CRB,
							modelName: EMARPOLModelName.MARPOL,
							weekStart: filters.startDate,
							weekEnd: filters.endDate,
							state: {
								$eq: filters?.state ?? undefined
							},
							sortOrder: filters?.sortOrder ?? undefined,
						},
                        preExecute() {
                            dispatch(job.active({}));
                        },
                        postExecute: {
                            onSuccess({ data }) {
                                const crbRecords = data.logs.docs.filter(
									(doc) => doc.marpolType === EMARPOLDocuments.CRB
								);
                                dispatch(
                                    crbActions.document.historySet(
										commonUtils.arrayToObject(crbRecords)
                                    )
                                );
                                dispatch(job.success({}));
                            },
                            onError() {
                                dispatch(job.error({}));
                            },
                            finally() {
                                dispatch(job.idle({}));
                            },
                        },
                    })
                );
                break;
            }
            default: {
                next(action);
                break;
            }
        }
    };
export default crbHistoryMiddleware;
